import LoadingIndicator from '@components/group/loading-indicator';
import FragmentLayout from '@shared/fragment-layout';
import Container from './container';
import SubNav from './sub-nav';

const Gantt = FragmentLayout(LoadingIndicator, null, Container, SubNav);

export default Gantt;
